import { Fragment } from 'react';
import { motion } from 'motion/react';
import { cn } from '@shared/lib';

export type StepState = 'done' | 'active' | 'upcoming';

export interface Step {
  label: string;
  state: StepState;
}

interface StepIndicatorProps {
  steps: Step[];
}

export function StepIndicator({ steps }: StepIndicatorProps) {
  return (
    <div className="inline-flex flex-wrap items-center gap-2.5 text-[12px] font-medium uppercase tracking-[0.16em] text-muted">
      {steps.map((s, i) => (
        <Fragment key={i}>
          {i > 0 && <span aria-hidden className="hidden h-px w-6 bg-line nav:block" />}
          {s.state === 'active' && (
            <motion.span
              aria-hidden
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
              className="block h-1.5 w-1.5 rounded-full bg-accent shadow-[0_0_0_4px_rgba(243,106,28,0.18)]"
            />
          )}
          <span
            className={cn(
              s.state === 'done' && 'text-fg',
              s.state === 'upcoming' && 'text-muted-2',
              s.state === 'active' && 'text-muted',
            )}
          >
            {s.state === 'done' && <span className="mr-1 text-accent">✓</span>}
            {s.label}
          </span>
        </Fragment>
      ))}
    </div>
  );
}
